// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3yqRq","title":"Header_title__2WUwY","side":"Header_side__vApq-"};